// "Dummy" implementation for non-HBA sites
module.exports = {
	init() {},
};
